import React, { useContext, useEffect, useState } from "react";

import { ShipmentPackagingType, ShipmentWeightUnit } from "app/pages/shipments/types/domain";
import { CargoGroupType } from "features/cargo-groups/api/types";
import { CargoGroupContext } from "features/cargo-groups/CargoGroupProvider";
import { FtlCargoGroupFormView } from "features/cargo-groups/views/FtlCargoGroupFormView";

export const CargoDetailsSection: React.FC = () => {
  const { topLevelCargoGroupIds, addCargoGroup } = useContext(CargoGroupContext);

  const [expanded, setExpanded] = useState<number | false>(0);

  useEffect(() => {
    if (topLevelCargoGroupIds.length === 0) {
      addCargoGroup(
        {
          cargo_group_type: CargoGroupType.HANDLING,
          packaging_type: ShipmentPackagingType.Pallets,
          count: 0,
          weight_unit: ShipmentWeightUnit.Lb,
        },
        { isTopLevelCargoGroup: true }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <FtlCargoGroupFormView expanded={expanded} onExpandChange={setExpanded} />;
};

export default CargoDetailsSection;
